import 'globalStyles/collection.scss';
import AccordionPresenter from '../product/presenters/AccordionPresenter';

const BOLD = (window.BOLD = window.BOLD || {});
BOLD.BMS = BOLD.BMS || {};
BOLD.BMS.BUILDS = BOLD.BMS.BUILDS || {};
BOLD.BMS.BUILDS.AccordionPresenter = AccordionPresenter;
